import React from 'react';
import { Link } from 'react-router-dom';
import headerLogo from '../assets/tappytray-header-logo-new.png';

interface SiteBrandLinkProps {
  to?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
}

/** Public site header: full wordmark + tagline (no separate text). */
const SiteBrandLink: React.FC<SiteBrandLinkProps> = ({
  to = '/',
  onClick,
  className = 'logo-wrap',
}) => {
  return (
    <Link to={to} className={className} onClick={onClick}>
      <img src={headerLogo} alt="TappyTray" className="logo-img" />
    </Link>
  );
};

export default SiteBrandLink;
